module.exports = __webpack_public_path__ + "static/media/level_17-18.c4bf5da2.jpg";